import * as s from "@gromia/components/theme/t.module.css";
import { tuple } from "@gromia/utils";
import cx from "classnames";
import React from "react";

const tags = tuple("h1", "h2", "h3", "h4", "h5", "p", "span");
const styles = tuple(
  "title",
  "titleLarge",
  "titleSmall",
  "titleSmaller",
  "p",
  "pill",
  "smallprint",
);

export type Tag = typeof tags[number];
export type Style = typeof styles[number];

type Props = {
  tag: Tag;
  s: Style;
  short?: boolean;
  children: NonNullable<React.ReactNode>;
  inverted?: boolean;
  id?: string;
  className?: string;
  noMargin?: boolean;
};

export const Text = (props: Props) => {
  const color = (x: string, d: string = s.textWhite) => props.inverted ? d : x;

  return React.createElement(
    props.tag,
    {
      id: props.id,
      className: cx(
        {
          title: cx(
            s.fontSizeLgHuge2,
            s.fontSizeMdHuge1,
            s.fontSizeLarge2,
            color(s.textDark),
            s.fontWeightLight,
            props.short ? cx(s.maxWidth950, s.mxAuto) : null,
          ),
          titleLarge: cx(
            s.fontSizeMdLarge2,
            s.fontSizeLarge1,
            color(s.textDark),
            s.fontWeightSemiBold,
            props.short ? cx(s.maxWidth760, s.mxAuto) : null,
          ),
          titleSmall: cx(
            s.fontSizeLgLarge1,
            s.fontSizeMdBig,
            s.fontSizeBase,
            color(s.textDark),
            s.fontWeightNormal,
            props.short ? cx(s.maxWidth760, s.mxAuto) : null,
            props.noMargin ? null : cx(s.mt4, s.mt1),
          ),
          titleSmaller: cx(s.textDark),
          p: cx(s.fontSizeMdBig, s.fontSizeBase, color("")),
          pill: cx(
            color(s.textMuted),
            s.fontSizeMdSmall1,
            s.fontSizeSmall2,
            s.fontWeightLight,
            s.textUppercase,
            s.mb2,
            // s.letterSpacing,
          ),
          smallprint: cx(color(s.textGray600), s.fontSizeMdSmall1),
        }[props.s],
      ),
    },
    props.children,
  );
};
